import { useEffect, useState } from "react";
import { wpData } from "../data/wpAPI";
import Section from "./section";
import joanaRay from "../assets/images/Joana_Ray-icon-32x32.png";
import iconIGyellow from "../assets/images/Instagram_Glyph_Yellow.svg";
import iconYTyellow from "../assets/images/YouTube_Glyph_Yellow.svg";

function Footer() {
  //fetch Privacy Policy page
  const [showModal, setModal] = useState(false);
  const [privacyPolicy, setPrivacyPolicy] = useState([]);

  //scroll position for the back to top link
  const [scrollPosition, setScrollPosition] = useState(0);
  const handleScroll = () => {
    const Yposition = window.pageYOffset;
    setScrollPosition(Yposition);
  };
  console.log(scrollPosition);

  useEffect(() => {
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  useEffect(() => {
    const fetchData = async () => {
      try {
        const rawData = await wpData("pages/3");
        setPrivacyPolicy(rawData);
      } catch (error) {
        console.error("Error fetching the Privacy Policy page:", error);
      }
    };
    fetchData();
  }, []);
  return (
    <>
      {showModal && (
        <dialog open>
          <div className="dialog-wrapper">
            <button onClick={() => setModal(false)}>
              <span class="material-symbols-outlined">close</span>
            </button>
            <Section
              key={privacyPolicy.id}
              slug={privacyPolicy.slug}
              title={privacyPolicy.title.rendered}
              content={privacyPolicy.content.rendered}
              wrapperClass={"dialog-block"}
            />
          </div>
        </dialog>
      )}
      <footer>
        <div className="wrapper full-width">
          <div className="content-wrapper">
            <div className="info-block">
              <button className="link-btn" onClick={() => setModal(true)}>
                Política de Privacidade
              </button>
              <span>
                <a href="https://www.livroreclamacoes.pt/Inicio/">
                  Livro de Reclamações
                </a>
              </span>
              <div className="credits">
                <p>Keidge 2025 &copy; all rights reserved</p>
                <p>
                  Design &amp; desenvolvimento:
                  <a href="https://joana.cc">
                    <img
                      src={joanaRay}
                      alt="icon Joana Ray"
                      title="Joana Ray"
                      width="18"
                      height="18"
                    />
                  </a>
                </p>
              </div>
            </div>
            <div id="contatos-footer">
              <ul className="lista-contatos">
                <li>
                  <span>mail</span>
                  <a href="mailto:geral@keidge.com">geral@keidge.com</a>
                </li>
                <li>
                  <span>call</span>tel. +351 918 805 850
                </li>
                <li>
                  <span>map</span>
                  <div>
                    Estrada Nacional 1, km95
                    <br /> 2460-615 Moleanos
                  </div>
                </li>
                <li>
                  <div className="lista-social">
                    <a href="https://www.instagram.com/keidge.film/">
                      <img
                        src={iconIGyellow}
                        alt="icon Instagram"
                        title="Keidge film on IG"
                        width="24"
                        height="24"
                      />
                    </a>{" "}
                    <a href="https://www.youtube.com/@KEIDGE_film">
                      <img
                        src={iconYTyellow}
                        alt="icon Youtube"
                        title="Keidge film on Youtube"
                        width="24"
                        height="24"
                      />
                    </a>
                  </div>
                </li>
              </ul>
              <a href="#main-content" title="back to top" id="back-to-top" {...(scrollPosition <= "100" ? { className: "hidden" } : {})}>
                <span className="material-symbols-outlined">
                  arrow_circle_up
                </span>
                <span className="screen-reader-text">back to top</span>
              </a>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
}
export default Footer;
